
import CatWikiCard from "../CatWikiCard/CatWikiCard";
import MoreBreedCard from "../CatWikiCard/MoreBreedCard/MoreBreedCard";
import HaveACatSection from "../HaveACatSection/HaveACatSection";

const MainCompnent = () => {
  return (
    <>
      
        
        <CatWikiCard></CatWikiCard>
        <MoreBreedCard />
        <HaveACatSection />
        
      
    </>
  );
};

export default MainCompnent;
